module.exports = __webpack_public_path__ + "static/media/cidades_visitadas.cd9459a6.jpg";